const darkThemeNotImplementedTechs = ['typescript']

export default defineNuxtPlugin({
  hooks: {
    'app:created': async () => {
      if (window) {
        const darkThemeNotImplemented = new Set(darkThemeNotImplementedTechs)

        const route = useRoute()
        const techPath = route.params.tech || route.path.split('/')[1]

        const isDarkThemeForced = darkThemeNotImplemented.has(techPath)

        if (isDarkThemeForced) {
          document.documentElement.classList.add('dark')
        }
      }
    }
  }
})
